export default __webpack_public_path__ + "static/sdc-5850cce00d69a5a83536596a2092ef9b.png";